// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import relativeTime from './directive/relativeTime'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@/components/ProLayout'
import FooterToolBar from '@/components/FooterToolbar'
import FileUpload from '@/components/FileUpload'
import themePluginConfig from '../config/themePluginConfig'
import { TableSetting } from '@/components'
import Nodata from '@/components/Nodata/index.vue'
import moment from 'moment'
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css' // 引入样式
import bootstrap from './core/bootstrap'
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './global.less' // global style
import { getDicts } from '@/api/system/dict/data'
import { getConfigKey } from '@/api/system/config'
import { addDateRange, handleTree, parseTime, resetForm, selectDictLabel, selectDictLabels, tableSorter } from '@/utils/ruoyi'
import { download, downloadGet, downloadPost } from '@/utils/request'
import downloadFile from '@/utils/download'
import regular from '@/utils/regular'
import WS from '@/utils/wsUrl'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 引入自定义css文件
import './assets/css/index.less'
// 引入echarts
import * as echarts from 'echarts'
import backSvg from '@/assets/back.svg'
import invalidSvg from '@/assets/img_invalid.svg'
import validSvg from '@/assets/img_valid.svg'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css' //

// const permissions = store.getters && store.getters.permissions
// console.log(permissions, 'permissions------------------');
// 全局方法挂载
Vue.prototype.$getters = store.getters
Vue.prototype.$echarts = echarts
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.downloadGet = downloadGet
Vue.prototype.downloadPost = downloadPost

Vue.prototype.downloadFile = downloadFile
Vue.prototype.handleTree = handleTree
Vue.prototype.tableSorter = tableSorter
Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype.regular = regular
Vue.prototype.$WS = WS
Vue.prototype.$backSvg = backSvg
Vue.prototype.$invalidSvg = invalidSvg
Vue.prototype.$validSvg = validSvg

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('footer-tool-bar', FooterToolBar)
Vue.component('file-upload', FileUpload)
Vue.component('table-setting', TableSetting)
Vue.component('no-data', Nodata)

Vue.use(permission)
Vue.use(style)
Vue.use(VueAwesomeSwiper)
Vue.use(relativeTime)
Vue.use(UmyUi)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999 // 设置图片预览组件的层级，确保能在其他组件之上
  }
})

window.umi_plugin_ant_themeVar = themePluginConfig.theme
new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex
  created: bootstrap,
  render: (h) => h(App)
}).$mount('#app')
